import { Typography } from "@commonlibs";
import styled, { css } from "styled-components";

export const SelectableCardRoot = styled.div<{ selected: boolean }>(
    ({ theme, selected }) => css`
        padding: 0px 5px;
        display: grid;
        grid-template-rows: 75% 10%;
        justify-items: center;
        align-items: center;
        aspect-ratio: 1.1 / 1;
        background-color: #eae8f5;
        border-radius: 10px;
        cursor: pointer;
        overflow: hidden;
        outline: ${selected ? `2px solid ${theme.palette.primary}` : "none"};
    `,
);

export const SelectableCardImage = styled.img(
    () => css`
        width: 55%;
    `,
);

export const SelectableCardText = styled(Typography)(
    () => css`
        line-height: 1.2;
    `,
);
